export const GENDER_OPTIONS = [
  { value: "male", description: "Male" },
  { value: "female", description: "Female" },
];

export const MARITAL_STATUS_OPTIONS = [
  { value: "single", description: "Single" },
  { value: "married", description: "Married" },
  { value: "other", description: "Other" },
];
